<template>
    <div id="main">
        <loader v-if="isLoading" />
        <div class="page page-container">
            <!-- CONTAINER DE ALERTAS -->
            <alert-container :messages="msgs" />

            <div class="vertical-flow">
                <div class="listing-header">
                    <div class="title-breadcrumb">
                        <h1 class="title">
                            {{ $t('adicionar-campanha') }}
                        </h1>
                    </div>
                    <div class="header-buttons">
                        <button class="delete-btn" type="button" @click="onFecharModal">
                            {{ $t('cancelar') }}
                        </button>
                        <button
                            v-if="(!isUpdate && permissao.create) || (isUpdate && permissao.update)"
                            class="save-btn"
                            type="button"
                            @click="save"
                            :disabled="isSaving"
                        >
                            {{ $t('salvar') }}
                            <button-loader :isSaving="isSaving" />
                        </button>
                    </div>
                </div>
                <br />
                <div class="form-columns-fit">
                    <div class="columns is-flex-wrap">
                        <div class="column is-2">
                            <v-input
                                :id="generateId(1)"
                                ref="idErpInput"
                                v-model="campanha.idcampanhaerp"
                                placeholder="placeholder-preencha"
                                :maxlength="30"
                                title="codigo"
                                uppercase
                                required
                                :invalid="!campanha.idcampanhaerp"
                                tooltipLabel="cod-ref"
                            />
                        </div>
                        <div class="column is-5">
                            <v-input
                                :id="generateId(2)"
                                ref="descricaoInput"
                                v-model="campanha.descricao"
                                placeholder="placeholder-preencha"
                                :maxlength="30"
                                title="descricao"
                                msg="msg-campo-obrigatorio"
                                :invalid="!campanha.descricao"
                                uppercase
                                required
                                tooltipLabel="info-descricao-generica"
                            />
                        </div>
                        <div class="column is-3">
                            <verified-date-picker
                                :id="generateId(3)"
                                v-model="date"
                                placeholder="selecione-uma-data"
                                title="data-validade"
                                :subtractDateYears="0"
                                :addDateYears="2"
                                :yearsRange="[-2, 10]"
                                :inForm="true"
                                :showToday="false"
                                :showClean="false"
                                required
                                tooltipLabel="info-data-validade-campanha"
                            />
                        </div>
                        <div class="column is-2">
                            <vss-select
                                :id="generateId(4)"
                                ref="statusSelect"
                                :options="statusSelect"
                                v-model="statusSelected"
                                class="no-clear"
                                :required="true"
                                title="situacao"
                                :invalid="!statusSelected"
                                :disabled="true"
                                tooltipLabel="info-situacao-generica"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import CampanhaService from '@/services/vendas/CampanhaService';
import CampanhaValidation from '@/services/validations/vendas/CampanhaValidation';
import Message from '@/models/Message';

export default {
    data() {
        return {
            integracao: this.$store.state.user.tabelasERPWebServer.includes('CAMPANHA'),
            service: new CampanhaService(this.$http, this.$router),
            isLoading: false,
            msgs: [],
            isSaving: false,
            validation: new CampanhaValidation(this.msgs),
            campanha: {
                id: null,
                descricao: null,
                datavalidade: null,
                situacao: null,
            },
            isUpdate: false,
            statusSelected: { id: 1, label: this.$t('ativo') },
            statusSelect: [
                { id: 0, label: this.$t('inativo') },
                { id: 1, label: this.$t('ativo') },
            ],
            date: new Date(this.$moment().add(1, 'days')),
        };
    },
    created() {
        this.permissao = this.hasPermissionAccess('vendas', 'vendas', 'ven-campanha');

        if (!this.permissao.create) {
            this.$router.push({
                name: 'acesso-nao-permitido',
                params: { tela: 'campanha' },
            });
        }
    },
    methods: {
        generateId(numberId) {
            return this.$route.name + '-' + numberId;
        },
        save() {
            this.isLoading = true;

            if (this.validation.validate(this.campanha, this.$refs)) {
                let campanhaTemp = Object.assign({}, this.campanha);
                campanhaTemp = this.mapTosave(campanhaTemp);
                campanhaTemp.situacao = this.statusSelected.id;
                campanhaTemp.datavalidade =
                    this.date != null ? this.$moment(this.date).format('YYYY-MM-DD') : null;

                this.invalidIcon = false;
                this.isSaving = true;

                this.service
                    .save(campanhaTemp)
                    .then((value) => {
                        if (value.message == null) {
                            let msg = 'msg-save-campanha';
                            this.msgs.push(new Message('success', msg, true));
                        } else {
                            if (this.$te(value.message)) {
                                this.msgs.push(new Message('alert', value.message, true));
                            } else {
                                this.msgs.push(
                                    new Message('error', 'msg-problema-realizar-acao', true)
                                );
                            }
                        }
                    })
                    .catch((e) => {
                        let message = e.body.message;
                        if (message && this.$te(message)) {
                            if (message == 'msg-codigo-duplicado-n') {
                                this.msgs.push(
                                    new Message(
                                        'alert',
                                        this.$t(message, { n: campanhaTemp.idcampanhaerp }),
                                        true,
                                        false
                                    )
                                );
                            } else {
                                this.msgs.push(new Message('alert', message, true));
                            }

                            return;
                        }

                        this.msgs.push(new Message('error', 'msg-problema-realizar-acao', true));
                    })
                    .finally(() => {
                        this.isSaving = false;
                        this.isLoading = false;
                        this.onFecharModal();
                    });
            } else {
                this.msgs.push(new Message('alert', 'msg-campos-obrigatorios', true));
                this.isLoading = false;
            }
        },
        onFecharModal() {
            this.$emit('fecharModal', true);
        },
    },
};
</script>
<style lang="scss" scoped>
#main {
    padding: 0 20px;
    height: auto;

    .page {
        position: relative;
    }
    #color {
        padding: 0 !important;
        height: 36px;
        cursor: pointer;
    }
}
</style>
